import ApiClient from "@/domain/core/utils/apiClient"
import client_core from "@/services/clients/client_core"

const client = new ApiClient(client_core)

const endpoints = {
    sales_total: 'dashboard/v2/stats/sales/summary/',
    photo_service_totals: 'dashboard/v2/stats/sales/photo-service/{id}/summary/',
    photo_service_events_totals: 'dashboard/v2/stats/sales/photo-service/{id}/',
    saas_payments_total: 'dashboard/v3/sales/saas_payments_total/',
    saas_payments_list: 'dashboard/v3/sales/saas_payments_list/',
}

class SalesReportService {
    getSalesTotal(params = {}) {
        return client.get(endpoints.sales_total, params)
    }
    
    getPhotoServiceTotals(photoServiceId, params = {}) {
        return client.get(endpoints.photo_service_totals.replace('{id}', photoServiceId), params)
    }
    
    getPhotoServiceEventsTotals(photoServiceId, params = {}) {
        return client.get(endpoints.photo_service_events_totals.replace('{id}', photoServiceId), params)
    }
    
    // New endpoints for SaaS payments
    getSaasPaymentsTotal(params = {}) {
        return client.get(endpoints.saas_payments_total, params)
    }
    
    getSaasPaymentsList(params = {}) {
        return client.get(endpoints.saas_payments_list, params)
    }
}

export default new SalesReportService()